// extracted by mini-css-extract-plugin
export var container = "block-title-mobile-module--container--bJVI-";
export var text = "block-title-mobile-module--text--1s_mk";
export var ecotrans = "block-title-mobile-module--ecotrans--1qyX9";
export var waste = "block-title-mobile-module--waste--33SU-";
export var imageContainer = "block-title-mobile-module--imageContainer--2BhA1";
export var image = "block-title-mobile-module--image--49r6H";